import { Component, inject, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { catchError, of, take } from "rxjs";
import {
  HardBtnComponent,
  HardFormModule,
  HardFormService,
  HardLoadingComponent,
  HardModalComponent,
  HardTranslatePipe,
  IHardFormField,
  HardFormFieldTypeEnum,
  IHardFormSelectParams,
} from "@hardcode-kz/ui";
import { DictionaryService } from "@dmms/core/http";
import { NotificationService } from "@dmms/core/notification";
import { BaseModalComponent } from "@modals/base-modal/base-modal.component";
import { IDictionaryCrudModalData } from "@app/shared/ui-kit/components/tables/ui-page-table/dictionary-crud-modal/dictionary-crud-modal.component";
import {
  ApiErrorFieldEnum,
  IBaseHttpResponse,
} from "@models/http/http-options";
import { AdministrationEndpoints } from "@dmms/shared/data-access/administration/types/administration-endpoints";

@Component({
  selector: "app-user-supervisor-modal",
  standalone: true,
  imports: [
    HardModalComponent,
    HardLoadingComponent,
    HardFormModule,
    HardBtnComponent,
    HardTranslatePipe,
  ],
  templateUrl: "./app-user-supervisor-modal.component.html",
})
export class AppUserSupervisorModalComponent
  extends BaseModalComponent<
    AppUserSupervisorModalComponent,
    IDictionaryCrudModalData
  >
  implements OnInit
{
  form!: FormGroup;
  loading = true;
  saving = false;

  private readonly formService = inject(HardFormService);
  private readonly dicService = inject(DictionaryService);
  private readonly notificationService = inject(NotificationService);

  fields: IHardFormField[] = [
    {
      title: "dicTable.supervisor",
      name: "supervisor",
      type: HardFormFieldTypeEnum.Dictionary,
      params: {
        dicType: `api/v1/${AdministrationEndpoints.AppUser}`,
        fieldNames: ["fullName"],
      } as IHardFormSelectParams,
    },
  ];

  ngOnInit(): void {
    this.form = this.formService.buildReactiveForm(this.fields);

    if (this.data.item) {
      const initialSupervisor = this.data.item.supervisorShortModel || null;
      this.form.patchValue({
        supervisor: initialSupervisor,
      });
    }

    this.loading = false;
  }

  save(): void {
    if (this.saving || this.loading || this.form?.invalid) return;

    this.saving = true;
    const val = this.form.getRawValue();
    const supervisorId = val.supervisor?.id || null;

    const version = this.data.config?.version || 1;
    const url = `v${version}/app-user/${this.data.item.id}/supervisor`;

    this.dicService
      .put(url, { supervisorId })
      .pipe(
        take(1),
        catchError((errorRes: HttpErrorResponse) => {
          this.notificationService.findAndShowErrors(
            errorRes,
            ApiErrorFieldEnum.Code,
          );
          return of(null);
        }),
      )
      .subscribe((res: IBaseHttpResponse) => {
        if (res?.isSuccess) {
          this.notificationService.success("ui.form.editSuccess");
          this.close(true);
        }
        this.saving = false;
      });
  }
}
